import { SchemaFn } from '@angular/forms/signals';
import { metadataSchema } from '@shared/components/form/field/shared/form-field.function';

export interface PropertyFilter {
    filter: string;
    name: string;
    city: string;
    branchIds: string[];
    types: string[];
}

export function createPropertyFilterModel(init?: Partial<PropertyFilter>): PropertyFilter {
    return {
        filter: init?.filter ?? '',
        name: init?.name ?? '',
        city: init?.city ?? '',
        branchIds: init?.branchIds ?? [],
        types: init?.types ?? [],
    };
}

export const propertyFilterSchema: SchemaFn<PropertyFilter> = (schema) => {
    metadataSchema(schema.filter, {
        displayName: 'Property.List.Filter.Filter',
        placeholder: 'Property.List.Filter.Filter',
    });
    metadataSchema(schema.name, {
        displayName: 'Property.List.Filter.Name',
        placeholder: 'Property.List.Filter.Name',
    });
    metadataSchema(schema.city, {
        displayName: 'Property.List.Filter.City',
        placeholder: 'Property.List.Filter.City',
    });
    metadataSchema(schema.branchIds, {
        displayName: 'Property.List.Filter.BranchIds',
        placeholder: 'Property.List.Filter.BranchIds',
    });
    metadataSchema(schema.types, {
        displayName: 'Property.List.Filter.Types',
        placeholder: 'Property.List.Filter.Types',
    });
};
